import { Col, Container, Row } from "react-bootstrap";
import { FaCopy, FaShareAlt } from "react-icons/fa";
import "./Invite.css";

const InviteLinkSection = () => {
  const referralLink = "https://appname.com/reffuyeoweduyhdfsvavdafcd...";

  const handleCopy = () => {
    navigator.clipboard.writeText(referralLink);
    alert("Referral link copied!");
  };

  return (
    <section className="invite-section">
      <Container>
        <Row>
          <div className="invite-div">
            <div className="row">

            {/* Left Side Text and Input */}
            <Col xl={12} md={12} sm={12}>
              <div className="invite-text">
                <h5 className="text">
                  Share your referral link with friends & earn exciting rewards{" "}<br />
                  <span>when they join.</span>
                </h5>

                <div className="referral-box">
                  <div className="referral-link">{referralLink}
                    <button className="icon-btn" onClick={handleCopy}>
                      <FaCopy />
                    </button>
                  </div>
                  <button className="share-btn">
                    Share <FaShareAlt />
                  </button>
                </div>
              </div>
            </Col>

            </div>

          </div>
        </Row>
      </Container>
    </section>
  );
};

export default InviteLinkSection;